import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router';
import { tentarRefresh } from '../lib/api';
import { TrocarSenha } from '../paginas/TrocarSenha';
import { useSessao } from '../lib/sessao';

/** Restaura a sessão pelo cookie de refresh ao abrir o site; sem sessão, manda para /entrar. */
export function RotaProtegida() {
  const { accessToken, cliente, restaurando, concluirRestauracao } = useSessao();

  useEffect(() => {
    if (!restaurando) return;
    if (accessToken) {
      concluirRestauracao();
      return;
    }
    void tentarRefresh().finally(concluirRestauracao);
  }, [restaurando, accessToken, concluirRestauracao]);

  if (restaurando) {
    return <p className="p-8 text-center text-sm text-neutral-500">Carregando…</p>;
  }
  if (!accessToken) return <Navigate to="/entrar" replace />;
  // Senha entregue pelo admin e ainda não trocada: a conta não abre antes disso. Vale
  // para o técnico de liberação, o único que recebe senha de outra pessoa.
  if (cliente?.precisaTrocarSenha) return <TrocarSenha />;
  return <Outlet />;
}
